/* DUNKPOINT site-wide behaviour:
   1. Drag-to-scroll product sliders with the left or right mouse button.
   2. Block the context menu and the common developer-tools shortcuts.
   3. Tuck the header away while scrolling down on phones.
   4. Search panel: popular searches on focus, live products while typing.
   5. Phone menu drawer, rebuilt to match the reference.
   6. Phone nav: first tap on a category opens its dropdown.
   Loaded with defer from the promo bar, so it runs before DOMContentLoaded and
   claims the sliders before the older header drag script can. */
(function () {
  if (window.dpGlobalReady) return;
  window.dpGlobalReady = true;

  var PHONE = '(max-width: 767px)';
  function isPhone() { return window.matchMedia(PHONE).matches; }

  /* Translated labels, printed by snippets/dp-strings.liquid. */
  var S = window.dpStrings || {};

  /* ---- things worth editing, all overridable from the theme ---------- */
  /* Popular searches shown when the search box is focused but still empty. */
  var POPULAR = window.DP_POPULAR || [
    'Lakers', 'Celtics', 'Warriors', 'Knicks', 'City Edition', 'Classics', 'Shorts'
  ];
  /* Collections behind the POPULAR tiles in the phone menu. */
  var MENU_TILES = window.DP_MENU_TILES || [
    { handle: 'best-sellers', label: S.tileBestSellers || 'Best sellers' },
    { handle: 'new-releases', label: S.tileNewReleases || 'New releases' },
    { handle: 'special-editions', label: S.tileSpecialEditions || 'Special editions' },
    { handle: 'classics', label: S.tileClassics || 'Classics' }
  ];
  /* Collection behind the Featured jerseys tiles. */
  var MENU_FEATURED = window.DP_MENU_FEATURED || 'best-sellers';
  /* Small print at the bottom of the phone menu. ACCOUNT is filled in from the
     theme's own account link, so it follows customer accounts being on or off. */
  var MENU_LINKS = window.DP_MENU_LINKS || [
    { label: S.faq || 'FAQ', href: '/pages/avada-faqs' },
    { label: S.contactUs || 'CONTACT US', href: '/pages/contact' }
  ];

  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  function money(amount) {
    var value = parseFloat(amount);
    if (!isFinite(value)) return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + currency;
    }
  }
  var SEARCH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';
  var CLOSE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  /* ---------------------------------------------------------- drag ---- */
  var DRAG_THRESHOLD = 5;
  var activeDrag = null;

  function snapPoints(track) {
    var first = track.firstElementChild;
    if (!first) return [0];
    var style = getComputedStyle(track);
    var padStart = parseFloat(style.scrollPaddingLeft) || parseFloat(style.paddingLeft) || 0;
    var max = track.scrollWidth - track.clientWidth;
    var points = Array.prototype.map.call(track.children, function (child) {
      return Math.min(max, Math.max(0, child.offsetLeft - track.offsetLeft - padStart));
    });
    points.push(max);
    return points;
  }

  function settle(track, startLeft, velocity) {
    var points = snapPoints(track);
    var current = track.scrollLeft;
    var movedRight = current > startLeft + 1 || velocity > 0.3;
    var movedLeft = current < startLeft - 1 || velocity < -0.3;
    var target = current;
    if (movedRight) {
      target = points.filter(function (p) { return p > current + 1; })[0];
      if (target === undefined) target = points[points.length - 1];
    } else if (movedLeft) {
      var before = points.filter(function (p) { return p < current - 1; });
      target = before.length ? before[before.length - 1] : 0;
    }
    track.scrollTo({ left: target, behavior: 'smooth' });
    /* Restore CSS snapping once the smooth scroll has finished. */
    var restore = function () { track.classList.remove('is-dragging'); };
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', restore, { once: true });
      setTimeout(restore, 900);
    } else {
      setTimeout(restore, 450);
    }
  }

  function onPointerDown(e) {
    if (e.pointerType !== 'mouse') return;          /* touch scrolls natively */
    if (e.button !== 0 && e.button !== 2) return;
    var track = e.currentTarget;
    if (track.scrollWidth <= track.clientWidth) return;
    activeDrag = {
      track: track,
      startX: e.clientX,
      startLeft: track.scrollLeft,
      lastX: e.clientX,
      lastT: performance.now(),
      velocity: 0,
      moved: false
    };
  }

  function onPointerMove(e) {
    var d = activeDrag;
    if (!d) return;
    var dx = e.clientX - d.startX;
    if (!d.moved) {
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      d.moved = true;
      d.track.classList.add('is-dragging');
      d.track.dataset.dpJustDragged = '1';
    }
    e.preventDefault();
    var now = performance.now();
    var dt = Math.max(1, now - d.lastT);
    d.velocity = (d.lastX - e.clientX) / dt;
    d.lastX = e.clientX;
    d.lastT = now;
    d.track.scrollLeft = d.startLeft - dx;
  }

  function onPointerUp() {
    var d = activeDrag;
    activeDrag = null;
    if (!d || !d.moved) return;
    settle(d.track, d.startLeft, d.velocity);
    setTimeout(function () { delete d.track.dataset.dpJustDragged; }, 50);
  }

  function enableDrag(track) {
    if (track.dataset.dpDragReady === '2') return;
    track.dataset.dpDragReady = '2';
    track.addEventListener('pointerdown', onPointerDown);
    /* A click that ends a drag must not open the product. */
    track.addEventListener('click', function (e) {
      if (track.dataset.dpJustDragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initDrag() {
    document.querySelectorAll('[data-dp-drag]').forEach(enableDrag);
  }

  window.addEventListener('pointermove', onPointerMove, { passive: false });
  window.addEventListener('pointerup', onPointerUp);
  window.addEventListener('pointercancel', onPointerUp);
  window.dpInitDrag = initDrag;

  /* --------------------------------------- context menu + dev tools ---- */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    /* Keep the menu in form fields so people can still paste. */
    if (t && t.closest && t.closest('input, textarea, [contenteditable="true"]')) return;
    e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    var key = (e.key || '').toLowerCase();
    var ctrl = e.ctrlKey || e.metaKey;
    var blocked =
      key === 'f12' ||
      (ctrl && e.shiftKey && (key === 'i' || key === 'j' || key === 'c' || key === 'k')) ||
      (e.metaKey && e.altKey && (key === 'i' || key === 'j' || key === 'c')) ||
      (ctrl && !e.shiftKey && key === 'u');
    if (blocked) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* ------------------------------------ header tucks away on phones ---- */
  /* The header slides on transform, which the compositor can animate without
     a layout pass - animating `top` made it stutter. A transform other than
     none turns the header into the containing block for the position:fixed
     menu drawer inside it, so the tuck is dropped entirely (is-no-tuck) while
     the drawer is open, and the resting state stays transform: none. */
  function initHeaderScroll() {
    var header = document.querySelector('.dp-header-section');
    if (!header || header.dataset.dpScrollReady) return;
    header.dataset.dpScrollReady = '2';

    var lastY = window.pageYOffset;
    var travel = 0;                 /* distance travelled in one direction */
    var ticking = false;
    var TRIGGER = 28;               /* intent needed before the header moves */

    function show() { header.classList.remove('is-tucked'); }

    function update() {
      ticking = false;
      var y = Math.max(0, window.pageYOffset);
      var delta = y - lastY;
      lastY = y;

      if (!isPhone() || header.classList.contains('is-no-tuck') ||
          document.body.classList.contains('dp-cart-open')) {
        travel = 0;
        show();
        return;
      }
      /* Always visible near the top, and never tuck over a bounce scroll. */
      if (y < 100) { travel = 0; show(); return; }
      if (Math.abs(delta) < 1) return;

      /* Reset the counter whenever the direction flips, so a change of mind
         starts from zero instead of fighting the previous direction. */
      if ((delta > 0) !== (travel > 0)) travel = 0;
      travel += delta;

      if (travel > TRIGGER) { header.classList.add('is-tucked'); travel = TRIGGER; }
      else if (travel < -TRIGGER) { show(); travel = -TRIGGER; }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    window.addEventListener('resize', function () { if (!isPhone()) show(); });
  }

  /* --------------------------------------------- search dropdown ---- */
  function renderPopular(panel, input) {
    panel.innerHTML = '';
    if (!POPULAR.length) { panel.hidden = true; return; }
    panel.hidden = false;
    panel.appendChild(h('p', 'dp-srch__head', S.popularSearches || 'Popular searches'));
    var list = h('div', 'dp-srch__list');
    POPULAR.forEach(function (term) {
      var row = h('button', 'dp-srch__row');
      row.type = 'button';
      row.innerHTML = '<span class="dp-srch__ico">' + SEARCH_ICON + '</span>';
      row.appendChild(h('span', 'dp-srch__label', term));
      row.addEventListener('click', function () {
        input.value = term;
        input.form.submit();
      });
      list.appendChild(row);
    });
    panel.appendChild(list);
  }

  function renderResults(panel, products, term) {
    panel.innerHTML = '';
    panel.hidden = false;
    if (!products.length) {
      panel.appendChild(h('p', 'dp-srch__empty', (S.noResults || 'No products match “[term]”.').split('[term]').join(term)));
      return;
    }
    panel.appendChild(h('p', 'dp-srch__head dp-srch__head--tiny', S.products || 'Products'));
    var list = h('div', 'dp-srch__list');
    products.forEach(function (product) {
      var row = document.createElement('a');
      row.className = 'dp-srch__row dp-srch__row--product';
      row.href = product.url;
      var thumb = h('span', 'dp-srch__thumb');
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      row.appendChild(thumb);
      row.appendChild(h('span', 'dp-srch__label', product.title));
      list.appendChild(row);
    });
    panel.appendChild(list);

    var all = document.createElement('a');
    all.className = 'dp-srch__all';
    all.href = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    all.textContent = (S.seeAllResults || 'See all results') + ' ';
    all.insertAdjacentHTML('beforeend', '<span aria-hidden="true">&rarr;</span>');
    panel.appendChild(all);
  }

  function initSearch() {
    var forms = document.querySelectorAll('.dp-header__search, .dp-header__mobile-search form');
    forms.forEach(function (form) {
      if (form.dataset.dpSearchReady) return;
      var input = form.querySelector('input[name="q"]');
      var wrap = form.querySelector('.dp-search');
      if (!input || !wrap) return;
      form.dataset.dpSearchReady = '1';
      form.classList.add('dp-srch');

      var panel = h('div', 'dp-srch__panel');
      panel.hidden = true;
      form.appendChild(panel);

      var clear = h('button', 'dp-srch__clear');
      clear.type = 'button';
      clear.setAttribute('aria-label', S.clearSearch || 'Clear search');
      clear.innerHTML = CLOSE_ICON;
      clear.hidden = true;
      wrap.appendChild(clear);

      var timer = null;
      var lastQuery = '';

      function open() {
        form.classList.add('is-open');
        document.body.classList.add('dp-search-open');
        if (input.value.trim().length < 2) renderPopular(panel, input);
      }
      function close() {
        form.classList.remove('is-open');
        document.body.classList.remove('dp-search-open');
        panel.hidden = true;
      }

      function fetchResults(term) {
        var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
        var url = base + '.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            /* A slower earlier request must not overwrite a newer one. */
            if (term !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(panel, products.map(function (p) {
              return {
                url: p.url,
                title: p.title,
                image: (p.featured_image && p.featured_image.url) || p.image
              };
            }), term);
          })
          .catch(function () { /* leave the previous panel contents in place */ });
      }

      input.addEventListener('focus', open);
      input.addEventListener('click', open);
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clear.hidden = term === '';
        lastQuery = term;
        clearTimeout(timer);
        if (term.length < 2) { renderPopular(panel, input); return; }
        timer = setTimeout(function () { fetchResults(term); }, 200);
      });
      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        lastQuery = '';
        input.focus();
        renderPopular(panel, input);
      });
      form.addEventListener('submit', close);
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && form.classList.contains('is-open')) { close(); input.blur(); }
      });
    });
  }

  /* --------------------------------------------- phone menu drawer ---- */
  function tile(href, imageUrl, label, contain) {
    var a = document.createElement('a');
    a.className = 'dp-menu__tile';
    a.href = href;
    if (imageUrl) {
      var img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      if (contain) img.className = 'is-contain';
      a.appendChild(img);
    }
    a.appendChild(h('span', 'dp-menu__tile-label', label));
    return a;
  }

  function collectionProducts(handle, limit) {
    return fetch('/collections/' + handle + '/products.json?limit=' + limit)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  /* The tile rows need product images, so they are filled in the first time
     the drawer is opened rather than on every page load. */
  function fillMenuTiles(sheet) {
    if (sheet.dataset.dpTilesReady) return;
    sheet.dataset.dpTilesReady = '1';
    var popularRow = sheet.querySelector('[data-dp-menu-popular]');
    var featuredRow = sheet.querySelector('[data-dp-menu-featured]');
    if (!popularRow || !featuredRow) return;

    MENU_TILES.forEach(function (entry) {
      collectionProducts(entry.handle, 1).then(function (products) {
        var image = products[0] && products[0].images && products[0].images[0];
        popularRow.appendChild(tile('/collections/' + entry.handle, image && image.src, entry.label));
      });
    });

    collectionProducts(MENU_FEATURED, 8).then(function (products) {
      if (!products.length) {
        var block = featuredRow.parentNode;
        if (block) block.hidden = true;
        return;
      }
      products.forEach(function (product) {
        var image = product.images && product.images[0];
        var price = product.variants && product.variants[0] && product.variants[0].price;
        featuredRow.appendChild(tile('/products/' + product.handle, image && image.src, money(price), true));
      });
    });
  }

  function initMenu() {
    var menu = document.querySelector('[data-dp-menu]');
    if (!menu || menu.dataset.dpMenuReady) return;
    var sheet = menu.querySelector('.dp-menu__sheet');
    if (!sheet) return;
    menu.dataset.dpMenuReady = '1';

    var header = document.querySelector('.dp-header-section');
    var headerInput = document.querySelector('.dp-header__search input[name="q"], .dp-header__mobile-search input[name="q"]');
    var placeholder = (headerInput && headerInput.getAttribute('placeholder')) || 'Search';

    /* --- black top bar: search field on the left, close on the right --- */
    var top = sheet.querySelector('.dp-menu__top');
    if (top) {
      top.innerHTML = '';
      var form = document.createElement('form');
      form.className = 'dp-menu__search';
      form.action = '/search';
      form.method = 'get';
      form.setAttribute('role', 'search');
      form.innerHTML =
        '<span class="dp-menu__search-ico">' + SEARCH_ICON + '</span>' +
        '<input type="search" name="q" autocomplete="off" placeholder="' + placeholder.replace(/"/g, '&quot;') + '">' +
        '<input type="hidden" name="options[prefix]" value="last">';
      top.appendChild(form);

      var close = h('button', 'dp-menu__close');
      close.type = 'button';
      close.setAttribute('aria-label', S.close || 'Close');
      close.innerHTML = CLOSE_ICON;
      close.addEventListener('click', function () { menu.removeAttribute('open'); });
      top.appendChild(close);
    }

    /* --- everything below the bar scrolls as one column --- */
    var scroller = h('div', 'dp-menu__scroll');
    var rows = [];
    Array.prototype.forEach.call(sheet.children, function (child) {
      if (child !== top) rows.push(child);
    });
    rows.forEach(function (row) { scroller.appendChild(row); });
    sheet.appendChild(scroller);

    /* Balance row, styled like the reference's "My Balance". */
    var pointsPill = document.querySelector('[data-dp-points-toggle]');
    if (pointsPill) {
      var balance = h('button', 'dp-menu__link dp-menu__link--balance');
      balance.type = 'button';
      var coin = pointsPill.querySelector('img, svg');
      if (coin) {
        var copy = coin.cloneNode(true);
        copy.classList.add('dp-menu__coin');
        balance.appendChild(copy);
      }
      balance.appendChild(h('span', 'dp-menu__link-text', S.myBalance || 'My Balance'));
      balance.addEventListener('click', function (e) {
        /* The header closes the points popover from a document click handler.
           Without stopping this click there, and without letting the drawer
           finish closing first, the panel would be shut again the instant the
           pill opens it. */
        e.stopPropagation();
        menu.removeAttribute('open');
        setTimeout(function () { pointsPill.click(); }, 0);
      });
      scroller.insertBefore(balance, scroller.firstChild);
    }

    /* Wrap the row labels so the chevron can sit hard against the edge. */
    scroller.querySelectorAll('.dp-menu__link, .dp-menu__group > summary').forEach(function (row) {
      if (row.querySelector('.dp-menu__link-text')) return;
      var text = h('span', 'dp-menu__link-text');
      while (row.firstChild) text.appendChild(row.firstChild);
      row.appendChild(text);
    });

    /* --- POPULAR + Featured jerseys tile rows, then the small print --- */
    var account = scroller.querySelector('.dp-menu__account');
    var extras = document.createDocumentFragment();

    function tileBlock(title, attr) {
      var block = h('div', 'dp-menu__block');
      block.appendChild(h('h3', 'dp-menu__block-title', title));
      var row = h('div', 'dp-menu__tiles');
      row.setAttribute(attr, '');
      block.appendChild(row);
      block.appendChild(h('div', 'dp-menu__rule'));
      return block;
    }
    extras.appendChild(tileBlock(S.popular || 'POPULAR', 'data-dp-menu-popular'));
    extras.appendChild(tileBlock(S.featuredJerseys || 'Featured jerseys', 'data-dp-menu-featured'));

    var links = h('div', 'dp-menu__small');
    MENU_LINKS.concat(account ? [{ label: S.account || 'ACCOUNT', href: account.getAttribute('href') }] : [])
      .forEach(function (item) {
        var a = document.createElement('a');
        a.href = item.href;
        a.textContent = item.label;
        links.appendChild(a);
      });
    extras.appendChild(links);
    if (account) account.remove();
    scroller.appendChild(extras);

    /* The drawer is position:fixed inside the header, so the header must not
       carry a transform while it is open. */
    menu.addEventListener('toggle', function () {
      if (header) {
        header.classList.toggle('is-no-tuck', menu.open);
        if (menu.open) header.classList.remove('is-tucked');
      }
      if (menu.open) fillMenuTiles(sheet);
    });
  }

  /* ------------------------------------- phone nav opens dropdowns ---- */
  function initMobileNav() {
    var nav = document.querySelector('.dp-header__nav');
    if (!nav || nav.dataset.dpNavReady) return;
    nav.dataset.dpNavReady = '1';
    var header = document.querySelector('.dp-header-section');

    /* The fade + arrow over the strip's right edge (dp-header-extras.css)
       goes away once there is nothing more to scroll to. */
    var strip = nav.closest('.dp-header');
    function syncEnd() {
      if (!strip) return;
      strip.classList.toggle('is-nav-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4);
    }
    nav.addEventListener('scroll', syncEnd, { passive: true });
    window.addEventListener('resize', syncEnd);
    syncEnd();

    function anyOpen() { return !!nav.querySelector('.dp-nav__item.is-open'); }

    function closeAll(except) {
      nav.querySelectorAll('.dp-nav__item.is-open').forEach(function (item) {
        if (item !== except) item.classList.remove('is-open');
      });
      if (header && !anyOpen()) header.classList.remove('is-no-tuck');
    }

    /* The panel is position:fixed so it escapes the nav strip's horizontal
       scroll, which means it needs to be told where the strip ends. The header
       also has to stay untransformed while it is open, or the fixed panel
       would be positioned against the header instead of the viewport. */
    function openItem(item) {
      closeAll(item);
      if (header) {
        header.classList.remove('is-tucked');
        header.classList.add('is-no-tuck');
      }
      var bottom = Math.round(nav.getBoundingClientRect().bottom) + 'px';
      document.documentElement.style.setProperty('--dp-navdrop-top', bottom);
      item.classList.add('is-open');
    }

    nav.addEventListener('click', function (e) {
      if (!isPhone()) return;
      var link = e.target.closest('.dp-nav__link');
      if (!link) return;
      var item = link.closest('.dp-nav__item');
      if (!item || !item.querySelector('.dp-nav__panel')) return;   /* no children: just go */
      /* First tap opens the dropdown; the View all row inside it is what
         takes you to the category itself. */
      e.preventDefault();
      if (item.classList.contains('is-open')) closeAll(null);
      else openItem(item);
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll(null);
    });
    window.addEventListener('scroll', function () {
      if (anyOpen()) closeAll(null);
    }, { passive: true });
    window.addEventListener('resize', function () { if (!isPhone()) closeAll(null); });
  }

  /* -------------------------------------------------------------- boot ---- */
  function boot() {
    initDrag();
    initHeaderScroll();
    initSearch();
    initMenu();
    initMobileNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
